import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronUp = (props) => {
    return (
        <Icon
            viewBox="0 0 12 12"
            fill="none"
            {...props}
            data-testid="chevron-up"
            aria-hidden="true"
        >
            <path
                id="arrow"
                d="M3 7.5L6 4.5L9 7.5"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default ChevronUp
